import script from "./ProfileAdditionalConfigPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileAdditionalConfigPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileAdditionalConfigPage.vue?vue&type=style&index=0&id=002fc180&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002fc180"]])

export default __exports__